import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Download, Infinity, CreditCard, ChevronDown, Star, ArrowRight, AlertTriangle, BookOpen, Users, TrendingUp, Globe, Briefcase, FileText, HelpCircle } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
// Image URLs
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/2KbaoPFPDArcgcvRWHHdN4/mockups_economia_.png',
  BONUS1: 'https://cdn.magicpatterns.com/uploads/6JxosyVSZjXjLscaapUHyG/bonus_maletin_de_act.png',
  BONUS2: 'https://cdn.magicpatterns.com/uploads/xdCZarQDHvWmR8sHQbcS62/bonus_primeros_auxilios.png',
  BONUS3: 'https://cdn.magicpatterns.com/uploads/7jPddC3JCCs6g7bjXSoGJ3/bonus_planificacion_anual.png',
  UPSELL: 'https://cdn.magicpatterns.com/uploads/9J3MioKiq1fVGdgGA4X9rp/upsell_economia_.png'
};
// Links
const LINKS = {
  MAIN_CHECKOUT: 'https://pagos.bienesparatuvida.online/cart/47855499280609:1',
  UPSELL_CHECKOUT: 'https://pagos.bienesparatuvida.online/cart/47878602260705:1'
};
export function SalesPage() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-white min-h-screen flex flex-col" data-id="element-5">
      <CountdownTimer data-id="element-6" />
      <SocialProofPopup data-id="element-7" />

      {/* SECTION 2: HERO */}
      <section className="bg-white py-8 md:py-12 px-4 text-center" data-id="element-8">
        <div className="max-w-4xl mx-auto" data-id="element-9">
          <span className="inline-block text-xs md:text-sm font-bold text-green-700 uppercase tracking-widest mb-4 bg-green-100 px-4 py-1.5 rounded-full shadow-sm" data-id="element-10">
            PARA DOCENTES DE ECONOMÍA EN SECUNDARIA
          </span>

          <p className="text-lg md:text-2xl text-gray-700 font-medium mb-6 max-w-2xl mx-auto" data-id="element-11">
            Resolvé todo tu año de Economía en un solo lugar y olvidate de
            planificar desde cero con el{' '}
            <span className="font-black text-gray-900" data-id="element-12">
              KIT COMPLETO ECONOMÍA LISTA
            </span>
          </p>

          <div onClick={scrollToPricing} className="cursor-pointer hover:opacity-95 transition-opacity mb-6" data-id="element-13">
            <img src={IMAGES.MAIN} alt="Kit Completo Economía Lista Mockup" className="w-full max-w-2xl mx-auto drop-shadow-2xl" data-id="element-14" />
          </div>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-15">
            Sistema completo de clases, secuencias, actividades y evaluaciones
            listas para usar en secundaria. Todo tu año resuelto.
          </p>

          <a href={LINKS.MAIN_CHECKOUT} className="inline-flex items-center justify-center bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-xl md:text-3xl py-4 px-8 md:px-12 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 mb-6 w-full md:w-auto" data-id="element-16">
            👉 SÍ, QUIERO ACCESO INMEDIATO
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base text-gray-600 font-medium mt-4" data-id="element-17">
            <span className="flex items-center gap-1" data-id="element-18">
              <CreditCard className="w-4 h-4" data-id="element-19" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-20">
              <Download className="w-4 h-4" data-id="element-21" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-22">
              <ShieldCheck className="w-4 h-4" data-id="element-23" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-24">
              <Infinity className="w-4 h-4" data-id="element-25" /> Acceso de por vida
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 3: PAIN POINTS */}
      <section className="bg-gray-50 py-12 md:py-20 px-4 border-t border-gray-200" data-id="element-26">
        <div className="max-w-3xl mx-auto" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-28">
            Si sos docente de Economía, esto te va a sonar familiar…
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-29">
            <p data-id="element-30">Llegás del colegio agotado/a y todavía tenés que planificar.</p>
            <p data-id="element-31">
              Horas armando clases sobre oferta y demanda, inflación, crisis
              económicas, sistema financiero, desarrollo, mercado laboral…
            </p>
            <p data-id="element-32">
              Preparando evaluaciones claras. Buscando actividades que realmente
              enganchen. Tratando de que los contenidos no queden solo en
              teoría.
            </p>
            <p className="font-bold text-gray-900" data-id="element-33">
              No es falta de capacidad. Es que te falta un sistema completo que
              te sostenga todo el año.
            </p>
          </div>
        </div>
      </section>

      {/* EXTRA STRATEGIC CTA */}
      <section className="bg-white py-8 px-4 text-center" data-id="element-34">
        <button onClick={scrollToPricing} className="bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-lg md:text-2xl py-4 px-8 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 w-full md:w-auto max-w-2xl" data-id="element-35">
          🔥 Quiero dejar de improvisar y tener todo resuelto
        </button>
      </section>

      {/* SECTION 4: SOLUTION */}
      <section className="bg-black text-white py-16 md:py-24 px-4 text-center" data-id="element-36">
        <div className="max-w-4xl mx-auto" data-id="element-37">
          <span className="inline-block bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-wider" data-id="element-38">
            La Solución
          </span>
          <h2 className="text-4xl md:text-6xl font-black mb-6" data-id="element-39">
            KIT COMPLETO ECONOMÍA LISTA
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto" data-id="element-40">
            Sistema integral de clases, actividades, proyectos y evaluaciones
            diseñadas específicamente para secundaria.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-lg md:text-xl font-bold text-[#22c55e]" data-id="element-41">
            <span className="flex items-center gap-2" data-id="element-42">
              <Check className="w-6 h-6" data-id="element-43" /> Listo
            </span>
            <span className="flex items-center gap-2" data-id="element-44">
              <Check className="w-6 h-6" data-id="element-45" /> Probado
            </span>
            <span className="flex items-center gap-2" data-id="element-46">
              <Check className="w-6 h-6" data-id="element-47" /> Organizado
            </span>
            <span className="flex items-center gap-2" data-id="element-48">
              <Check className="w-6 h-6" data-id="element-49" /> Aplicable
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 5: CONTENTS */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-50">
        <div className="max-w-5xl mx-auto" data-id="element-51">
          <div className="text-center mb-16" data-id="element-52">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-53">
              ¿QUÉ INCLUYE EL KIT COMPLETO ECONOMÍA LISTA?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-54">
              ✅ Contenido de cada cuadernillo
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-55">
            {/* Cuadernillo 1 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-56">
              <div className="flex items-start gap-4 mb-4" data-id="element-57">
                <BookOpen className="w-8 h-8 text-blue-600 flex-shrink-0" data-id="element-58" />
                <div data-id="element-59">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-60">
                    Cuadernillo Economía 1 – Introducción a la Economía
                  </h3>
                  <p className="text-gray-600 italic mb-4" data-id="element-61">
                    Bases conceptuales, microeconomía inicial y mirada
                    cotidiana.
                  </p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-700 text-sm md:text-base" data-id="element-62">
                <li className="flex items-start gap-2" data-id="element-63">
                  📌 Qué es la economía y su vínculo con la vida cotidiana
                </li>
                <li className="flex items-start gap-2" data-id="element-64">
                  📌 Necesidades, recursos y escasez
                </li>
                <li className="flex items-start gap-2" data-id="element-65">
                  📌 Bienes y servicios
                </li>
                <li className="flex items-start gap-2" data-id="element-66">
                  📌 Producción, distribución y consumo
                </li>
                <li className="flex items-start gap-2" data-id="element-67">
                  📌 Decisiones económicas individuales (base de la
                  microeconomía)
                </li>
                <li className="flex items-start gap-2" data-id="element-68">
                  📌 Organización social y economía
                </li>
                <li className="flex items-start gap-2" data-id="element-69">
                  📌 Desarrollo conceptual claro y ordenado
                </li>
                <li className="flex items-start gap-2" data-id="element-70">
                  📌 Bibliografía y material de apoyo
                </li>
              </ul>
            </div>

            {/* Cuadernillo 2 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-71">
              <div className="flex items-start gap-4 mb-4" data-id="element-72">
                <TrendingUp className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-73" />
                <div data-id="element-74">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-75">
                    Cuadernillo Economía 2 – Sistemas económicos, Estado y
                    Macroeconomía
                  </h3>
                  <p className="text-gray-600 italic mb-4" data-id="element-76">
                    Organización económica, rol del Estado y mirada
                    macroeconómica.
                  </p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-700 text-sm md:text-base" data-id="element-77">
                <li className="flex items-start gap-2" data-id="element-78">
                  🏛️ Qué es un sistema económico
                </li>
                <li className="flex items-start gap-2" data-id="element-79">
                  🏛️ Economía de mercado, planificada y mixta
                </li>
                <li className="flex items-start gap-2" data-id="element-80">
                  🏛️ Microeconomía y Macroeconomía: diferencias y relaciones
                </li>
                <li className="flex items-start gap-2" data-id="element-81">
                  🏛️ El Estado como actor económico
                </li>
                <li className="flex items-start gap-2" data-id="element-82">
                  🏛️ Impuestos, gasto público y servicios públicos
                </li>
                <li className="flex items-start gap-2" data-id="element-83">
                  🏛️ Estado, mercado y sociedad
                </li>
                <li className="flex items-start gap-2" data-id="element-84">
                  🏛️ Contenidos explicados sin tecnicismos
                </li>
                <li className="flex items-start gap-2" data-id="element-85">
                  🏛️ Bibliografía y recursos didácticos
                </li>
              </ul>
            </div>

            {/* Cuadernillo 3 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-86">
              <div className="flex items-start gap-4 mb-4" data-id="element-87">
                <Users className="w-8 h-8 text-purple-600 flex-shrink-0" data-id="element-88" />
                <div data-id="element-89">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-90">
                    Cuadernillo Economía 3 – Trabajo, ingresos y desigualdad
                  </h3>
                  <p className="text-gray-600 italic mb-4" data-id="element-91">
                    Micro y macro desde la dimensión social de la economía.
                  </p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-700 text-sm md:text-base" data-id="element-92">
                <li className="flex items-start gap-2" data-id="element-93">👥 Trabajo y empleo</li>
                <li className="flex items-start gap-2" data-id="element-94">
                  👥 Ingresos y distribución del ingreso
                </li>
                <li className="flex items-start gap-2" data-id="element-95">
                  👥 Microeconomía del trabajo y los ingresos
                </li>
                <li className="flex items-start gap-2" data-id="element-96">
                  👥 Desigualdad social y económica
                </li>
                <li className="flex items-start gap-2" data-id="element-97">
                  👥 Economía, derechos sociales y ciudadanía
                </li>
                <li className="flex items-start gap-2" data-id="element-98">
                  👥 Impacto de la economía en la vida cotidiana
                </li>
                <li className="flex items-start gap-2" data-id="element-99">
                  👥 Enfoque social y ciudadano
                </li>
                <li className="flex items-start gap-2" data-id="element-100">
                  👥 Bibliografía y actividades sugeridas
                </li>
              </ul>
            </div>

            {/* Cuadernillo 4 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-101">
              <div className="flex items-start gap-4 mb-4" data-id="element-102">
                <Globe className="w-8 h-8 text-orange-600 flex-shrink-0" data-id="element-103" />
                <div data-id="element-104">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-105">
                    Cuadernillo Economía 4 – Economía argentina y mundo actual
                  </h3>
                  <p className="text-gray-600 italic mb-4" data-id="element-106">
                    Macroeconomía aplicada al contexto nacional y global.
                  </p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-700 text-sm md:text-base" data-id="element-107">
                <li className="flex items-start gap-2" data-id="element-108">
                  🇦🇷 Estructura productiva argentina
                </li>
                <li className="flex items-start gap-2" data-id="element-109">
                  🇦🇷 Actividades económicas
                </li>
                <li className="flex items-start gap-2" data-id="element-110">
                  🇦🇷 Estado y economía nacional
                </li>
                <li className="flex items-start gap-2" data-id="element-111">
                  🇦🇷 Macroeconomía argentina
                </li>
                <li className="flex items-start gap-2" data-id="element-112">
                  🇦🇷 Economía argentina en el contexto mundial
                </li>
                <li className="flex items-start gap-2" data-id="element-113">
                  🇦🇷 Problemas económicos actuales (enfoque conceptual)
                </li>
                <li className="flex items-start gap-2" data-id="element-114">
                  🇦🇷 Análisis claro y actualizado
                </li>
                <li className="flex items-start gap-2" data-id="element-115">
                  🇦🇷 Bibliografía y material de referencia
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6: RESULTS */}
      <section className="bg-white py-16 px-4 border-t border-gray-100" data-id="element-116">
        <div className="max-w-4xl mx-auto" data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12" data-id="element-118">
            Resultados que Transforman
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-119">
            <div data-id="element-120">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-121">
                <span className="bg-blue-100 text-blue-600 p-2 rounded-lg" data-id="element-122">
                  <Users className="w-6 h-6" data-id="element-123" />
                </span>
                Para tus Estudiantes
              </h3>
              <ul className="space-y-4" data-id="element-124">
                <li className="flex items-start gap-3" data-id="element-125">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-126" />
                  <span className="text-gray-700 text-lg" data-id="element-127">
                    Comprenden la economía con claridad
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-128">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-129" />
                  <span className="text-gray-700 text-lg" data-id="element-130">
                    Analizan la inflación y crisis reales
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-131">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-132" />
                  <span className="text-gray-700 text-lg" data-id="element-133">
                    Participan más en clase
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-134">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-135" />
                  <span className="text-gray-700 text-lg" data-id="element-136">
                    Debaten con fundamentos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-137">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-138" />
                  <span className="text-gray-700 text-lg" data-id="element-139">
                    Conectan la Economía con su vida cotidiana
                  </span>
                </li>
              </ul>
            </div>

            <div data-id="element-140">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-141">
                <span className="bg-purple-100 text-purple-600 p-2 rounded-lg" data-id="element-142">
                  <Briefcase className="w-6 h-6" data-id="element-143" />
                </span>
                Para Vos como Docente
              </h3>
              <ul className="space-y-4" data-id="element-144">
                <li className="flex items-start gap-3" data-id="element-145">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-146" />
                  <span className="text-gray-700 text-lg" data-id="element-147">
                    Ahorrás horas de planificación
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-148">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-149" />
                  <span className="text-gray-700 text-lg" data-id="element-150">
                    Enseñás con estructura y seguridad
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-151">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-152" />
                  <span className="text-gray-700 text-lg" data-id="element-153">
                    Tenés todo organizado por unidad
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-154">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-155" />
                  <span className="text-gray-700 text-lg" data-id="element-156">
                    Llegás sin estrés al cierre del año
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-157">
                  <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-158" />
                  <span className="text-gray-700 text-lg" data-id="element-159">
                    Recuperás tiempo personal
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-160">
            <a href={LINKS.MAIN_CHECKOUT} className="inline-block bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-xl md:text-2xl py-4 px-12 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200" data-id="element-161">
              👉 QUIERO LOGRAR ESTO
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 7: SOCIAL PROOF BAR */}
      <section className="bg-gray-900 text-white py-8 px-4 text-center" data-id="element-162">
        <p className="text-lg font-medium text-gray-400 uppercase tracking-widest mb-2" data-id="element-163">
          No dejes pasar esta oportunidad
        </p>
        <p className="text-2xl md:text-3xl font-bold" data-id="element-164">
          Más de 500 docentes ya transformaron su año escolar.
        </p>
      </section>

      {/* SECTION 8: BONUSES */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-165">
        <div className="max-w-6xl mx-auto" data-id="element-166">
          <div className="text-center mb-16" data-id="element-167">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-168">
              🎁 Bonos Gratis Hoy
            </h2>
            <p className="text-2xl text-gray-600" data-id="element-169">
              Te llevás 3 bonos exclusivos{' '}
              <span className="text-[#22c55e] font-bold" data-id="element-170">
                GRATIS por el día de hoy
              </span>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-171">
            {/* Bonus 1 */}
            <div className="flex flex-col h-full bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow cursor-pointer" onClick={scrollToPricing} data-id="element-172">
              <div className="h-36 w-full bg-gray-100 flex items-center justify-center" data-id="element-173">
                <img src={IMAGES.BONUS1} alt="Maletín de Actividades" className="h-full w-auto object-contain" data-id="element-174" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-175">
                <span className="text-[#22c55e] font-bold text-sm tracking-wider mb-2" data-id="element-176">
                  🎁 BONO 1 – GRATIS
                </span>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-177">
                  📦 Maletín de Actividades para Clases
                </h3>
                <p className="text-gray-600" data-id="element-178">
                  Un recurso práctico con decenas de actividades listas para
                  usar en el aula.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="flex flex-col h-full bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow cursor-pointer" onClick={scrollToPricing} data-id="element-179">
              <div className="h-36 w-full bg-gray-100 flex items-center justify-center" data-id="element-180">
                <img src={IMAGES.BONUS2} alt="Guía Primeros Auxilios" className="h-full w-auto object-contain" data-id="element-181" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-182">
                <span className="text-[#22c55e] font-bold text-sm tracking-wider mb-2" data-id="element-183">
                  🎁 BONO 2 – GRATIS
                </span>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-184">
                  🩺 Guía Docente de Primeros Auxilios
                </h3>
                <p className="text-gray-600" data-id="element-185">
                  Explica de forma clara y práctica cómo actuar ante emergencias
                  escolares
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="flex flex-col h-full bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow cursor-pointer" onClick={scrollToPricing} data-id="element-186">
              <div className="h-36 w-full bg-gray-100 flex items-center justify-center" data-id="element-187">
                <img src={IMAGES.BONUS3} alt="Guía Planificación Anual" className="h-full w-auto object-contain" data-id="element-188" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-189">
                <span className="text-[#22c55e] font-bold text-sm tracking-wider mb-2" data-id="element-190">
                  🎁 BONO 3 – GRATIS
                </span>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-191">
                  📘 Guía Maestra de Planificación Anual
                </h3>
                <p className="text-gray-600" data-id="element-192">
                  Incluye planificaciones listas, organizadas por temas y
                  niveles
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 9: PRICING */}
      <section id="pricing" className="bg-black text-white py-10 md:py-14 px-4" data-id="element-193">
        <div className="max-w-2xl mx-auto text-center" data-id="element-194">
          <div className="animate-pulse mb-4" data-id="element-195">
            <span className="bg-red-600 text-white font-bold px-4 py-2 rounded-full text-sm md:text-base uppercase tracking-wider whitespace-nowrap" data-id="element-196">
              🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
            </span>
          </div>

          <div className="bg-gray-900 border-2 border-[#22c55e] rounded-2xl p-6 md:p-8 shadow-2xl relative overflow-hidden" data-id="element-197">
            <div className="flex justify-center mb-4" data-id="element-198">
              <span className="bg-[#22c55e] text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase" data-id="element-199">
                ⭐ Más Popular
              </span>
            </div>

            <h2 className="text-2xl md:text-4xl font-black mb-4 leading-tight" data-id="element-200">
              KIT COMPLETO ECONOMÍA LISTA
            </h2>

            <div className="flex flex-wrap justify-center gap-3 text-sm text-gray-300 mb-6" data-id="element-201">
              <span className="flex items-center gap-1" data-id="element-202">
                <Check className="w-4 h-4 text-[#22c55e]" data-id="element-203" /> Acceso de por vida
              </span>
              <span className="flex items-center gap-1" data-id="element-204">
                <Check className="w-4 h-4 text-[#22c55e]" data-id="element-205" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-206">
                <Check className="w-4 h-4 text-[#22c55e]" data-id="element-207" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-208">
                <Check className="w-4 h-4 text-[#22c55e]" data-id="element-209" /> 3 Bonos incluidos
              </span>
            </div>

            <div className="flex flex-col items-center mb-6" data-id="element-210">
              <span className="text-gray-500 text-base line-through mb-1" data-id="element-211">
                Precio regular $49.990 ARS
              </span>
              <span className="text-4xl md:text-6xl font-black text-[#22c55e]" data-id="element-212">
                HOY $19.990 ARS
              </span>
              <span className="text-gray-400 text-sm mt-1" data-id="element-213">
                Pago único · Pagarás en pesos argentinos
              </span>
            </div>

            <a href={LINKS.MAIN_CHECKOUT} className="block w-full bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-xl md:text-2xl py-5 px-4 rounded-xl shadow-lg transform hover:scale-[1.02] transition-all duration-200 mb-4" data-id="element-214">
              👉 SÍ, QUIERO EL KIT COMPLETO
            </a>

            <div className="text-gray-400 text-sm font-medium" data-id="element-215">
              <p className="mb-1" data-id="element-216">Métodos de pago seguros:</p>
              <div className="flex flex-wrap justify-center gap-3 uppercase text-xs md:text-sm" data-id="element-217">
                <span data-id="element-218">Mercado Pago</span>
                <span data-id="element-219">•</span>
                <span data-id="element-220">Visa</span>
                <span data-id="element-221">•</span>
                <span data-id="element-222">Mastercard</span>
                <span data-id="element-223">•</span>
                <span data-id="element-224">Transferencia por whatsapp</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10: HOW IT WORKS */}
      <section className="bg-white py-16 px-4" data-id="element-225">
        <div className="max-w-4xl mx-auto text-center" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12" data-id="element-227">
            🔽 ¿Cómo recibís el material?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-228">
            <div className="relative" data-id="element-229">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-2xl font-bold text-gray-900 mx-auto mb-4 border-2 border-gray-200" data-id="element-230">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-231">Paso 1</h3>
              <p className="text-gray-600" data-id="element-232">
                Realizás la compra e ingresás tu correo.
              </p>
            </div>
            <div className="relative" data-id="element-233">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-2xl font-bold text-gray-900 mx-auto mb-4 border-2 border-gray-200" data-id="element-234">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-235">Paso 2</h3>
              <p className="text-gray-600" data-id="element-236">
                Finalizás el pago de forma segura.
              </p>
            </div>
            <div className="relative" data-id="element-237">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-2xl font-bold text-gray-900 mx-auto mb-4 border-2 border-gray-200" data-id="element-238">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-239">Paso 3</h3>
              <p className="text-gray-600" data-id="element-240">
                Recibís automáticamente el link de descarga en tu correo.
              </p>
            </div>
          </div>

          <div className="mt-12 bg-yellow-50 border border-yellow-200 rounded-lg p-4 inline-block" data-id="element-241">
            <p className="text-yellow-800 flex items-center justify-center gap-2 font-medium" data-id="element-242">
              <AlertTriangle className="w-5 h-5" data-id="element-243" />
              ⚠️ Si no lo ves en tu bandeja principal, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 11: UPSELL */}
      <section className="bg-white py-10 px-4" data-id="element-244">
        <div className="max-w-3xl mx-auto" data-id="element-245">
          <div className="border-4 border-dashed border-[#22c55e] rounded-2xl p-6 md:p-8 bg-white shadow-xl relative" data-id="element-246">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#22c55e] text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider shadow-md whitespace-nowrap text-center" data-id="element-247">
              ⭐ MÁS POPULAR
            </div>

            <h2 className="text-xl md:text-3xl font-black text-center text-gray-900 mb-6 mt-4" data-id="element-248">
              KIT COMPLETO ECONOMÍA + GESTION Y ORGANIZACIONES
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center mb-6" data-id="element-249">
              <div className="cursor-pointer hover:opacity-95 transition-opacity" onClick={scrollToPricing} data-id="element-250">
                <img src={IMAGES.UPSELL} alt="Kit Completo + Gestión" className="w-full max-w-xs mx-auto rounded-lg shadow-lg" data-id="element-251" />
              </div>
              <div data-id="element-252">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-253">
                  <span className="text-[#22c55e]" data-id="element-254">🎯</span> ¿Qué incluye este
                  Módulo Extra?
                </h3>
                <ul className="space-y-2" data-id="element-255">
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-256">
                    <span className="text-gray-900 font-bold" data-id="element-257">•</span> Kit
                    completo Economía
                  </li>
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-258">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-259" />{' '}
                    Teoría de las Organizaciones
                  </li>
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-260">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-261" />{' '}
                    Gestión Organizacional
                  </li>
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-262">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-263" />{' '}
                    Proyecto Organizacional completo
                  </li>
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-264">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-265" />{' '}
                    Actividades prácticas aplicables en clase
                  </li>
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-266">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-267" />{' '}
                    Explicaciones claras y directas (sin teoría innecesaria)
                  </li>
                  <li className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-268">
                    <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-269" />{' '}
                    Material listo para secundaria
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center border-t border-gray-100 pt-6" data-id="element-270">
              <div className="flex flex-col items-center justify-center gap-1 mb-4" data-id="element-271">
                <span className="text-gray-500 text-lg line-through" data-id="element-272">
                  $34.990 ARS
                </span>
                <span className="text-3xl md:text-4xl font-black text-[#22c55e]" data-id="element-273">
                  HOY $24.990 ARS
                </span>
                <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm" data-id="element-274">
                  Ahorrás $10.000 ARS
                </span>
              </div>

              <a href={LINKS.UPSELL_CHECKOUT} className="inline-block w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200" data-id="element-275">
                👉 SÍ, QUIERO EL SUPER MEGA PACK
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 12: GUARANTEE */}
      <section className="bg-white py-16 px-4 border-t border-gray-100" data-id="element-276">
        <div className="max-w-3xl mx-auto text-center" data-id="element-277">
          <ShieldCheck className="w-20 h-20 text-[#22c55e] mx-auto mb-6" data-id="element-278" />
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-279">
            Garantía de Satisfacción Total
          </h2>
          <p className="text-xl text-gray-600" data-id="element-280">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* SECTION 13: TESTIMONIALS */}
      <section className="bg-gray-50 py-16 md:py-20 px-4" data-id="element-281">
        <div className="max-w-5xl mx-auto" data-id="element-282">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12" data-id="element-283">
            Testimonios de Docentes en Argentina
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-284">
            {[{
            text: 'Ahora organizo todo el año sin estrés. Es increíble el tiempo que ahorro.',
            author: 'Natalia G.',
            loc: 'Córdoba'
          }, {
            text: 'Mis estudiantes entienden la inflación y las crisis con ejemplos reales.',
            author: 'Martín R.',
            loc: 'Buenos Aires'
          }, {
            text: 'Las clases cambiaron por completo. Todo está más claro y estructurado.',
            author: 'Laura P.',
            loc: 'Mendoza'
          }, {
            text: 'Antes tardaba horas buscando material. Ahora tengo todo listo.',
            author: 'Cecilia M.',
            loc: 'Rosario'
          }, {
            text: 'Las simulaciones de mercado hacen que participen todos.',
            author: 'Diego F.',
            loc: 'Tucumán'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-285">
                <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-286">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-287" />)}
                </div>
                <p className="text-gray-700 mb-4 italic" data-id="element-288">"{t.text}"</p>
                <div className="font-bold text-gray-900 text-sm" data-id="element-289">
                  {t.author} –{' '}
                  <span className="text-gray-500 font-normal" data-id="element-290">{t.loc}</span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 14: FAQ */}
      <section className="bg-white py-16 px-4" data-id="element-291">
        <div className="max-w-3xl mx-auto" data-id="element-292">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-293">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-294">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'Recibís todo en formato PDF, listo para descargar e imprimir o usar en formato digital.'
          }, {
            q: '¿Puedo imprimir el material?',
            a: 'Sí, podés imprimir todo el material las veces que necesites.'
          }, {
            q: '¿Para qué año sirve?',
            a: 'El kit está diseñado para todos los años de secundaria donde se dicte Economía.'
          }, {
            q: '¿Necesito materiales especiales?',
            a: 'No, solo necesitás una computadora o celular para descargar el material.'
          }, {
            q: '¿Cuánto tarda en llegar?',
            a: 'El acceso es inmediato. Apenas completás el pago, recibís el link de descarga en tu correo.'
          }].map((faq, i) => <details key={i} className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-md transition-all duration-200" data-id="element-295">
                <summary className="flex items-center justify-between cursor-pointer p-6 font-bold text-gray-900 list-none" data-id="element-296">
                  {faq.q}
                  <ChevronDown className="w-5 h-5 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-297" />
                </summary>
                <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-298">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* SECTION 15: FINAL CTA */}
      <section className="bg-black text-white py-16 md:py-24 px-4 text-center" data-id="element-299">
        <div className="max-w-4xl mx-auto" data-id="element-300">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-301">
            ¿Listo/a para transformar tu año en Economía?
          </h2>
          <p className="text-xl text-gray-400 mb-10" data-id="element-302">
            Sumate a docentes que ya dejaron de improvisar.
          </p>

          <a href={LINKS.MAIN_CHECKOUT} className="inline-block bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-xl md:text-3xl py-5 px-10 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 mb-6" data-id="element-303">
            👉 QUIERO EMPEZAR AHORA
          </a>

          <p className="text-gray-500 font-bold uppercase tracking-widest text-sm" data-id="element-304">
            📈 KIT COMPLETO ECONOMÍA LISTA
          </p>
        </div>
      </section>

      {/* SECTION 16: FOOTER */}
      <footer className="bg-gray-900 text-gray-500 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-305">
        <p className="mb-4" data-id="element-306">© 2026 Kit Completo Economía Lista™</p>
        <div className="flex justify-center gap-4" data-id="element-307">
          <span className="hover:text-white cursor-pointer" data-id="element-308">Términos</span>
          <span className="hover:text-white cursor-pointer" data-id="element-309">Privacidad</span>
          <span className="hover:text-white cursor-pointer" data-id="element-310">Soporte</span>
        </div>
      </footer>
    </div>;
}